import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import * as React from 'react';
import React__default, { Suspense } from 'react';
import { StyleSheet, SafeAreaView, ScrollView, Platform, StatusBar } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { useTranslation } from 'react-i18next';
import Toast from 'react-native-toast-notifications';
import { A as AppTopBar } from './index-88946c45.esm.js';

const AppToast = props => {
  const {
    currentTheme
  } = useTheme();
  // const { message, isVisible, setIsVisible, onDismiss, duration } = useToast();
  useTranslation();
  generateStyles(currentTheme);

  // const toastConfig = {
  //   success: ({ text1, text2, ...rest }) => (
  //     <BaseToast
  //       {...rest}
  //       style={{
  //         borderLeftColor: currentTheme?.theme?.start_base_button_colour,
  //         backgroundColor: currentTheme?.theme?.backgroundContrastColor,
  //       }}
  //       contentContainerStyle={{ paddingHorizontal: 15 }}
  //       text1Style={{
  //         fontSize: currentTheme?.theme?.medium_font_size,
  //         fontFamily: "normalFont",
  //       }}
  //       text1={t(text1)}
  //       text2={t(text2)}
  //       trailingIcon={assets.icons.close}
  //     />
  //   ),
  // };

  return /*#__PURE__*/React.createElement(Toast, {
    placement: "bottom",
    offset: 20
  })
  // <Toast
  //   config={toastConfig}
  //   autoHide={true}
  //   ref={(ref) => Toast.setRef(ref)}
  // />
  // <Snackbar
  //   duration={duration}
  //   visible={isVisible}
  //   onDismiss={() => {
  //     setIsVisible(false);
  //     onDismiss();
  //   }}
  //   action={{
  //     label: t("Dismiss"),
  //     onPress: () => {},
  //   }}
  //   style={styles.container}
  // >
  //   <View>
  //     <AppText>{message}</AppText>
  //   </View>
  // </Snackbar>
  ;
};

const generateStyles = props => {
  var _props$theme;
  return StyleSheet.create({
    container: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.backgroundContrastColor,
      flex: 1,
      justifyContent: "space-between"
    }
  });
};
AppToast.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppToast"
};

function AppBaseScreen(_ref) {
  let {
    style,
    children,
    isTopBarDisplayed,
    isScrollable = true,
    isNotificationDisplayed,
    canNavigateBack,
    contentContainerStyle,
    backgroundColor,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = generateStyle(currentTheme, backgroundColor);
  return /*#__PURE__*/React__default.createElement(Suspense, {
    fallback: "loading"
  }, /*#__PURE__*/React__default.createElement(SafeAreaView, _extends({
    style: [styles.container, style]
  }, props), isTopBarDisplayed && /*#__PURE__*/React__default.createElement(AppTopBar, {
    canNavigateBack: canNavigateBack,
    isNotificationDisplayed: isNotificationDisplayed
  }), isScrollable ? /*#__PURE__*/React__default.createElement(ScrollView, {
    contentContainerStyle: contentContainerStyle
  }, children) : children, /*#__PURE__*/React__default.createElement(AppToast, null)));
}
const generateStyle = (props, backgroundColor) => {
  var _props$theme;
  return StyleSheet.create({
    container: {
      flex: 1,
      overflow: "hidden",
      backgroundColor: backgroundColor || (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.baseScreenBackgroundColor),
      // backgroundColor: "yellow",

      // justifyContent: "center",
      paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0
    }
  });
};
AppBaseScreen.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppBaseScreen",
  "props": {
    "isScrollable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppBaseScreen as A };
